let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9VX13")).then(() => parcelRequire('1VFmu'));